module.exports = {
	"textures": [
		{
			"image": "BallStart.png",
			"format": "RGBA8888",
			"size": {
				"w": 150,
				"h": 150
			},
			"scale": 1,
			"frames": [
				{
					"filename": "4.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 227,
						"y": 57,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "6.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 185,
						"y": 32,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 12,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "7.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 160,
						"y": 27,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 23,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "8.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 133,
						"y": 27,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 34,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "9.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 108,
						"y": 32,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 45,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "10.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 86,
						"y": 42,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 56,
						"y": 1,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "21.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 106,
						"y": 261,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 66,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "22.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 131,
						"y": 267,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 77,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "23.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 157,
						"y": 267,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 88,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "24.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 182,
						"y": 262,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 99,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "38.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 187,
						"y": 33,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 110,
						"y": 1,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "39.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 168,
						"y": 28,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 120,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "40.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 149,
						"y": 26,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 131,
						"y": 1,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "41.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 129,
						"y": 27,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 1,
						"y": 11,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "42.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 110,
						"y": 31,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 12,
						"y": 11,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "43.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 93,
						"y": 38,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 23,
						"y": 11,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "49.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 28,
						"y": 124,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 34,
						"y": 11,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "55.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 58,
						"y": 230,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 44,
						"y": 11,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "59.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 123,
						"y": 265,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 55,
						"y": 11,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "60.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 142,
						"y": 267,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 65,
						"y": 11,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "62.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 180,
						"y": 263,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 76,
						"y": 11,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "63.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 198,
						"y": 256,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 87,
						"y": 11,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "78.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 215,
						"y": 47,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 98,
						"y": 11,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "81.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 174,
						"y": 29,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 108,
						"y": 11,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "82.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 158,
						"y": 27,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 118,
						"y": 11,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "83.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 142,
						"y": 26,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 129,
						"y": 11,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "85.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 112,
						"y": 31,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 140,
						"y": 11,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "86.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 98,
						"y": 36,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 1,
						"y": 21,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "92.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 36,
						"y": 97,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 12,
						"y": 21,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "101.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 54,
						"y": 226,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 22,
						"y": 21,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "105.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 103,
						"y": 260,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 33,
						"y": 21,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "106.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 117,
						"y": 264,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 43,
						"y": 21,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "107.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 132,
						"y": 267,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 54,
						"y": 21,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "108.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 148,
						"y": 267,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 65,
						"y": 21,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "109.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 164,
						"y": 266,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 76,
						"y": 21,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "110.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 179,
						"y": 263,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 87,
						"y": 21,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "125.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 255,
						"y": 94,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 98,
						"y": 21,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "130.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 219,
						"y": 50,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 109,
						"y": 21,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "132.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 199,
						"y": 38,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 120,
						"y": 21,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "134.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 178,
						"y": 30,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 131,
						"y": 21,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "142.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 86,
						"y": 42,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 141,
						"y": 21,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "135.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 166,
						"y": 28,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 1,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "136.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 154,
						"y": 26,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 12,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "137.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 142,
						"y": 26,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 23,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "138.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 130,
						"y": 27,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 34,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "139.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 118,
						"y": 29,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 45,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "143.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 76,
						"y": 48,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 56,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "144.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 67,
						"y": 55,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 67,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "153.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 26,
						"y": 148,
						"w": 8,
						"h": 8
					},
					"frame": {
						"x": 78,
						"y": 31,
						"w": 8,
						"h": 8
					}
				},
				{
					"filename": "165.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 98,
						"y": 258,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 88,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "166.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 109,
						"y": 262,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 99,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "167.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 120,
						"y": 265,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 110,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "168.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 132,
						"y": 267,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 121,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "169.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 144,
						"y": 267,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 132,
						"y": 31,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "170.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 156,
						"y": 267,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 1,
						"y": 41,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "172.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 180,
						"y": 263,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 12,
						"y": 41,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "173.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 191,
						"y": 259,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 23,
						"y": 41,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "176.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 221,
						"y": 242,
						"w": 9,
						"h": 8
					},
					"frame": {
						"x": 34,
						"y": 41,
						"w": 9,
						"h": 8
					}
				},
				{
					"filename": "0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 267,
						"y": 146,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 45,
						"y": 41,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 264,
						"y": 120,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 55,
						"y": 41,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "2.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 256,
						"y": 96,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 66,
						"y": 41,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "3.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 244,
						"y": 75,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 77,
						"y": 41,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "5.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 207,
						"y": 42,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 88,
						"y": 41,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "11.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 66,
						"y": 56,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 99,
						"y": 41,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 49,
						"y": 74,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 109,
						"y": 41,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "13.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 36,
						"y": 95,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 120,
						"y": 41,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "14.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 29,
						"y": 119,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 131,
						"y": 41,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "15.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 26,
						"y": 145,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 141,
						"y": 41,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "16.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 28,
						"y": 171,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 1,
						"y": 51,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "17.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 35,
						"y": 195,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 11,
						"y": 51,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "18.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 47,
						"y": 217,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 22,
						"y": 51,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "19.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 64,
						"y": 235,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 33,
						"y": 51,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "20.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 83,
						"y": 250,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 44,
						"y": 52,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "25.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 205,
						"y": 252,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 55,
						"y": 52,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "26.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 226,
						"y": 238,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 66,
						"y": 52,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "27.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 242,
						"y": 220,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 76,
						"y": 52,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "28.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 255,
						"y": 198,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 87,
						"y": 52,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "29.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 264,
						"y": 175,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 98,
						"y": 52,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "30.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 267,
						"y": 149,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 108,
						"y": 52,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "31.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 266,
						"y": 129,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 118,
						"y": 52,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "32.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 262,
						"y": 110,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 128,
						"y": 52,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "33.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 255,
						"y": 92,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 138,
						"y": 52,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "34.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 245,
						"y": 76,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 1,
						"y": 62,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "35.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 233,
						"y": 62,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 12,
						"y": 62,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "36.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 219,
						"y": 50,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 23,
						"y": 62,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "48.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 33,
						"y": 105,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 34,
						"y": 62,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "37.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 204,
						"y": 40,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 44,
						"y": 63,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "44.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 77,
						"y": 47,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 55,
						"y": 63,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "45.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 62,
						"y": 59,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 66,
						"y": 63,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "46.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 50,
						"y": 72,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 77,
						"y": 63,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "47.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 40,
						"y": 88,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 88,
						"y": 63,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "50.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 26,
						"y": 143,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 99,
						"y": 63,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "51.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 27,
						"y": 163,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 109,
						"y": 63,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "52.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 31,
						"y": 181,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 119,
						"y": 63,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "53.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 37,
						"y": 199,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 129,
						"y": 63,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "54.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 46,
						"y": 215,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 140,
						"y": 63,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "56.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 72,
						"y": 242,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 1,
						"y": 73,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "57.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 87,
						"y": 252,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 12,
						"y": 73,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "58.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 104,
						"y": 260,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 23,
						"y": 73,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "61.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 162,
						"y": 266,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 34,
						"y": 73,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "64.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 214,
						"y": 246,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 44,
						"y": 74,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "65.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 229,
						"y": 235,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 55,
						"y": 74,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "66.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 241,
						"y": 221,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 66,
						"y": 74,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "67.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 252,
						"y": 206,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 77,
						"y": 74,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "68.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 260,
						"y": 189,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 87,
						"y": 74,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "69.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 265,
						"y": 170,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 97,
						"y": 74,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "70.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 267,
						"y": 151,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 107,
						"y": 74,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "71.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 267,
						"y": 134,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 117,
						"y": 74,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "72.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 264,
						"y": 119,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 127,
						"y": 74,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "73.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 260,
						"y": 104,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 137,
						"y": 74,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "74.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 254,
						"y": 91,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 1,
						"y": 84,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "75.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 246,
						"y": 78,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 11,
						"y": 84,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "76.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 237,
						"y": 66,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 22,
						"y": 84,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "77.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 226,
						"y": 56,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 33,
						"y": 84,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "79.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 202,
						"y": 39,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 44,
						"y": 85,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "80.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 188,
						"y": 33,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 55,
						"y": 85,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "84.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 127,
						"y": 27,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 66,
						"y": 85,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "87.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 84,
						"y": 42,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 77,
						"y": 85,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "88.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 72,
						"y": 50,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 88,
						"y": 85,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "89.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 61,
						"y": 60,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 99,
						"y": 85,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "90.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 51,
						"y": 71,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 110,
						"y": 85,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "91.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 43,
						"y": 83,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 121,
						"y": 85,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "93.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 31,
						"y": 111,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 131,
						"y": 85,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "94.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 27,
						"y": 126,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 141,
						"y": 85,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "95.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 26,
						"y": 141,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 1,
						"y": 95,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "96.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 26,
						"y": 157,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 11,
						"y": 95,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "97.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 28,
						"y": 172,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 21,
						"y": 95,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "98.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 32,
						"y": 187,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 31,
						"y": 95,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "99.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 38,
						"y": 201,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 42,
						"y": 96,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "100.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 45,
						"y": 214,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 53,
						"y": 96,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "102.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 65,
						"y": 236,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 64,
						"y": 96,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "103.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 76,
						"y": 245,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 75,
						"y": 96,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "104.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 89,
						"y": 253,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 86,
						"y": 96,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "111.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 193,
						"y": 258,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 97,
						"y": 96,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "112.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 207,
						"y": 251,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 108,
						"y": 96,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "113.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 219,
						"y": 243,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 118,
						"y": 96,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "114.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 230,
						"y": 233,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 129,
						"y": 96,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "115.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 240,
						"y": 222,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 140,
						"y": 96,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "116.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 249,
						"y": 210,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 1,
						"y": 106,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "117.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 256,
						"y": 197,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 11,
						"y": 106,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "118.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 261,
						"y": 183,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 21,
						"y": 106,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "119.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 265,
						"y": 168,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 32,
						"y": 106,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "120.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 267,
						"y": 153,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 42,
						"y": 107,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "121.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 267,
						"y": 139,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 52,
						"y": 107,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "122.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 266,
						"y": 127,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 62,
						"y": 107,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "123.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 263,
						"y": 115,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 72,
						"y": 107,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "124.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 260,
						"y": 104,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 82,
						"y": 107,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "126.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 250,
						"y": 83,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 92,
						"y": 107,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "127.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 243,
						"y": 74,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 102,
						"y": 107,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "128.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 236,
						"y": 65,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 113,
						"y": 107,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "129.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 228,
						"y": 57,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 124,
						"y": 107,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "131.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 209,
						"y": 43,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 135,
						"y": 107,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "133.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 189,
						"y": 33,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 1,
						"y": 117,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "140.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 107,
						"y": 32,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 12,
						"y": 117,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "141.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 96,
						"y": 36,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 22,
						"y": 117,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "145.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 59,
						"y": 62,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 33,
						"y": 118,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "146.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 51,
						"y": 71,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 43,
						"y": 118,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "147.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 45,
						"y": 80,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 54,
						"y": 118,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "148.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 39,
						"y": 90,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 64,
						"y": 118,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "149.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 34,
						"y": 101,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 74,
						"y": 118,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "150.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 30,
						"y": 112,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 84,
						"y": 118,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "151.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 28,
						"y": 123,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 95,
						"y": 118,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "152.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 26,
						"y": 135,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 105,
						"y": 118,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "154.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 26,
						"y": 160,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 115,
						"y": 118,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "155.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 28,
						"y": 171,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 125,
						"y": 118,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "156.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 31,
						"y": 183,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 135,
						"y": 118,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "157.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 35,
						"y": 194,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 1,
						"y": 128,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "158.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 40,
						"y": 204,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 11,
						"y": 128,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "159.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 46,
						"y": 214,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 21,
						"y": 128,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "160.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 53,
						"y": 223,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 31,
						"y": 129,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "161.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 60,
						"y": 232,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 41,
						"y": 129,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "162.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 69,
						"y": 239,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 52,
						"y": 129,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "163.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 78,
						"y": 246,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 62,
						"y": 129,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "164.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 87,
						"y": 252,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 73,
						"y": 129,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "171.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 168,
						"y": 265,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 84,
						"y": 129,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "174.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 201,
						"y": 254,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 95,
						"y": 129,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "175.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 211,
						"y": 248,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 106,
						"y": 129,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "177.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 229,
						"y": 234,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 117,
						"y": 129,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "178.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 237,
						"y": 226,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 128,
						"y": 129,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "179.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 244,
						"y": 217,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 139,
						"y": 129,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "180.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 251,
						"y": 207,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 1,
						"y": 139,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "181.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 256,
						"y": 197,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 11,
						"y": 139,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "182.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 260,
						"y": 186,
						"w": 9,
						"h": 9
					},
					"frame": {
						"x": 22,
						"y": 140,
						"w": 9,
						"h": 9
					}
				},
				{
					"filename": "183.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 264,
						"y": 175,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 33,
						"y": 140,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "184.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 266,
						"y": 163,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 43,
						"y": 140,
						"w": 8,
						"h": 9
					}
				},
				{
					"filename": "185.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 300,
						"h": 300
					},
					"spriteSourceSize": {
						"x": 267,
						"y": 151,
						"w": 8,
						"h": 9
					},
					"frame": {
						"x": 53,
						"y": 140,
						"w": 8,
						"h": 9
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:be1621a90541ac1d3fd6a52761b5ce27:83cd40930932c50fecf9693d59202ecd:cbb56d375cb4e14ea8f54843ad8cb53b$"
	}
}
;